// Otomatik teşhis bulgu kartı: önem, güven, kanıt, etkilenen işlemler, önerilen çözüm
import { AlertTriangle, CheckCircle2, HelpCircle, Info } from 'lucide-react';

export const SEV = {
  kritik: ['Kritik', 'bg-rose-100 text-rose-800 ring-rose-200', 'border-l-rose-500'],
  uyari: ['Uyarı', 'bg-amber-100 text-amber-800 ring-amber-200', 'border-l-amber-400'],
  bilgi: ['Bilgi', 'bg-sky-100 text-sky-800 ring-sky-200', 'border-l-sky-400'],
};
export const CONF = { yuksek: 'Yüksek güven', orta: 'Orta güven', dusuk: 'Düşük güven' };
const CONF_HINT = { yuksek: 'Doğrudan ölçüm ve yeterli örnek', orta: 'Ölçüm var ama dolaylı ya da örnek sınırlı', dusuk: 'Kesin teşhis değil' };

export const Badges = ({ severity, confidence, testId }) => (
  <div className="flex flex-wrap items-center gap-1.5" data-testid={testId}>
    <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ring-1 ${SEV[severity][1]}`}>{SEV[severity][0]}</span>
    <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-700 ring-1 ring-slate-200" title={CONF_HINT[confidence]}>{CONF[confidence]}</span>
  </div>
);

const List = ({ title, items, icon: Icon, testId }) => (items?.length ? (
  <div data-testid={testId}><p className="mb-1 text-xs font-semibold uppercase tracking-wide text-slate-500">{title}</p>
    <ul className="space-y-1">{items.map((t, i) => <li key={i} className="flex gap-2 text-sm text-slate-700"><Icon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-slate-400" />{t}</li>)}</ul></div>
) : null);

const fmtG = (ms) => (ms >= 1000 ? `${(ms / 1000).toFixed(2).replace('.', ',')} sn` : `${ms} ms`);
const Gain = ({ g, i }) => (
  <p className="mt-3 rounded-lg bg-slate-50 px-3 py-2 text-sm text-slate-700" data-testid={`perf-finding-gain-${i}`}>
    <span className="font-semibold">Tahmini kazanım: </span>
    {g ? (g.basis === 'p95_olagan'
      ? `Olağan değere dönülürse P95'te yaklaşık ${fmtG(g.ms)} (%${g.pct}) iyileşme.`
      : `Bu darboğaz tamamen giderilirse işlem başına en fazla ~${fmtG(g.ms)} (%${g.pct}) kısalma (kuramsal üst sınır).`)
      : 'Tahmin edilemiyor (doğrudan ölçüm veya en az 30 örnek yok).'}
  </p>
);

export const FindingCard = ({ f, i }) => (
  <article className={`rounded-xl border border-l-4 border-slate-200 bg-white p-5 ${SEV[f.severity][2]}`} data-testid={`perf-finding-${i}`}>
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="flex items-start gap-2">
        {f.kind === 'undetermined' ? <HelpCircle className="mt-0.5 h-5 w-5 text-slate-400" /> : <AlertTriangle className="mt-0.5 h-5 w-5 text-slate-500" />}
        <div><h4 className="font-semibold text-slate-900" data-testid={`perf-finding-title-${i}`}>{f.title}</h4><p className="mt-0.5 text-sm text-slate-600">{f.summary}</p></div>
      </div>
      <Badges severity={f.severity} confidence={f.confidence} testId={`perf-finding-badges-${i}`} />
    </div>
    <div className="mt-4 grid gap-4 md:grid-cols-2">
      <List title="Ölçüm kanıtı" items={f.evidence} icon={Info} testId={`perf-finding-evidence-${i}`} />
      <List title="Önerilen çözüm" items={f.fix} icon={CheckCircle2} testId={`perf-finding-fix-${i}`} />
    </div>
    {f.affected?.length > 0 && <div className="mt-3 flex flex-wrap gap-1.5" data-testid={`perf-finding-affected-${i}`}>
      <span className="text-xs text-slate-500">Etkilenen:</span>{f.affected.map(a => <span key={a} className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-xs text-slate-700">{a}</span>)}</div>}
    <Gain g={f.gain} i={i} />
    <p className="mt-3 text-xs text-slate-400">{f.samples?.toLocaleString('tr-TR')} örnek · {f.measured ? 'doğrudan ölçüm' : 'dolaylı / kesin olmayan'}</p>
  </article>
);
